import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-email-confirm',
  templateUrl: './email-confirm.component.html'
})
export class EmailConfirmComponent implements OnInit {
  message: string = 'Verifying your email, Loading...';
  time:number = 3;
  verified:boolean = false;
  constructor(
    private afAuth: AngularFireAuth, 
    private activateRoute: ActivatedRoute,
    private router: Router
  ) {
    const code = this.activateRoute.snapshot.queryParams['oobCode'];

    this.afAuth
      .applyActionCode(code)
      .then(() => {
        this.message = 'Your email verified successfully, Now you can login to system .'
        this.verified = true;
        // do redirect to choose plan after successful verification
        var refreshIntervalId = setInterval(() => {
          this.time--;
          
          /* later */
          setTimeout(() => {
            clearInterval(refreshIntervalId);
            if (this.router.url.includes('reset-password')) {
              this.router.navigate(['/reset-password']);
            } 
          }, 3000)
        }, 1000);
        
      })
      .catch(err => {
        // show error message
        this.message = 'Error in verifying email, Please try again and contact administrator';
        console.log('Error: ', err);
      });
  }

  ngOnInit(): void {

  }

}
